/*global $*/
/*eslint no-undef: "error"*/

export default class WidgetSocial {
    classBlock = 'widget-social--block'
    classBlockOpen = 'widget-social-open'
    classButton = 'widget-social--button'
    classIFrame = 'widget-social--iframe'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            let objIFrame = $(this).closest(`.${self.classBlock}`).find(`.${self.classIFrame}`)
            let iframe = objIFrame.html().replaceAll('iframe-hidden', 'iframe')

            $(this).closest(`.${self.classBlock}`).addClass(self.classBlockOpen)
            objIFrame.html(iframe)
        })
    }
}
